export default () => {
  return {
    initial: {
      query: '',
      status: '',
      // price_from: undefined,
      // price_to: undefined,
    },
    configuration: {
      query: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'accounts_marketplace::category.filters.input.label',
        placeholder: 'accounts_marketplace::category.filters.input.label',
        order: 1,
        type: 'input',
      },
      status: {
        subbutton: {
          isVisible: (value = '') => !!value,
        },
        label:
          'accounts_marketplace::category.filters.dropdown.items.status.label',
        position: 'dropdown',
        type: 'radio group',
        optionLabelPrefix:
          'accounts_marketplace::category.filters.dropdown.items.status.options.',
        options: ['pending', 'error', 'success'],
      },
    },
  }
}
